"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ISSUE_COLUMN_SORT_ATTRS = exports.ISSUE_COLUMN_KEYS = exports.ISSUE_COLUMN_DATA_KEYS = exports.COLUMN_KEY_BY_SORT_ATTRS = exports.COLUMN_KEY_BY_DATA_KEY = void 0;
var _invert = _interopRequireDefault(require("lodash/invert"));
var _sdk = require("../../../../sdk");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// these keys are defined so our table logic is not reliant on the particular shape of the
// issue object we receive from the backend
let ISSUE_COLUMN_KEYS = exports.ISSUE_COLUMN_KEYS = /*#__PURE__*/function (ISSUE_COLUMN_KEYS) {
  ISSUE_COLUMN_KEYS["STATUS"] = "STATUS";
  ISSUE_COLUMN_KEYS["ID"] = "ID";
  ISSUE_COLUMN_KEYS["TITLE"] = "TITLE";
  ISSUE_COLUMN_KEYS["LOCATION_DETAILS"] = "LOCATION_DETAILS";
  ISSUE_COLUMN_KEYS["CREATED_BY"] = "CREATED_BY";
  ISSUE_COLUMN_KEYS["ASSIGNED_TO"] = "ASSIGNED_TO";
  ISSUE_COLUMN_KEYS["WATCHERS"] = "WATCHERS";
  ISSUE_COLUMN_KEYS["COMPANY"] = "COMPANY";
  ISSUE_COLUMN_KEYS["START_DATE"] = "START_DATE";
  ISSUE_COLUMN_KEYS["DUE_DATE"] = "DUE_DATE";
  ISSUE_COLUMN_KEYS["DOCUMENT"] = "DOCUMENT";
  ISSUE_COLUMN_KEYS["ATTACHMENTS"] = "ATTACHMENTS";
  ISSUE_COLUMN_KEYS["COMMENTS"] = "COMMENTS";
  ISSUE_COLUMN_KEYS["LBS_LOCATION"] = "LBS_LOCATION";
  ISSUE_COLUMN_KEYS["ROOT_CAUSE"] = "ROOT_CAUSE";
  ISSUE_COLUMN_KEYS["ISSUE_TYPE_CATEGORY"] = "ISSUE_TYPE_CATEGORY";
  ISSUE_COLUMN_KEYS["ISSUE_TYPE"] = "ISSUE_TYPE";
  ISSUE_COLUMN_KEYS["OPENED_AT"] = "OPENED_AT";
  ISSUE_COLUMN_KEYS["CLOSED_AT"] = "CLOSED_AT";
  ISSUE_COLUMN_KEYS["CREATED_AT"] = "CREATED_AT";
  ISSUE_COLUMN_KEYS["UPDATED_AT"] = "UPDATED_AT";
  ISSUE_COLUMN_KEYS["UPDATED_BY"] = "UPDATED_BY";
  ISSUE_COLUMN_KEYS["DESCRIPTION"] = "DESCRIPTION";
  ISSUE_COLUMN_KEYS["PLACEMENT"] = "PLACEMENT";
  ISSUE_COLUMN_KEYS["IS_PUBLISHED"] = "IS_PUBLISHED";
  ISSUE_COLUMN_KEYS["REFERENCES"] = "REFERENCES";
  ISSUE_COLUMN_KEYS["DELETED_BY"] = "DELETED_BY";
  ISSUE_COLUMN_KEYS["DELETED_ON"] = "DELETED_ON";
  return ISSUE_COLUMN_KEYS;
}({});
// maps the keys we've defined to the issue's data shape
// @TODO: add stamp, and comments once they exist in the backend
const ISSUE_COLUMN_DATA_KEYS = exports.ISSUE_COLUMN_DATA_KEYS = Object.freeze({
  [ISSUE_COLUMN_KEYS.STATUS]: "status",
  [ISSUE_COLUMN_KEYS.ID]: "displayId",
  [ISSUE_COLUMN_KEYS.TITLE]: "title",
  [ISSUE_COLUMN_KEYS.LOCATION_DETAILS]: "locationDetails",
  [ISSUE_COLUMN_KEYS.CREATED_BY]: "createdBy",
  [ISSUE_COLUMN_KEYS.CREATED_AT]: "createdAt",
  [ISSUE_COLUMN_KEYS.ASSIGNED_TO]: "assignedTo",
  [ISSUE_COLUMN_KEYS.WATCHERS]: "watchers",
  [ISSUE_COLUMN_KEYS.COMPANY]: "assignedTo",
  [ISSUE_COLUMN_KEYS.START_DATE]: "startDate",
  [ISSUE_COLUMN_KEYS.DUE_DATE]: "dueDate",
  [ISSUE_COLUMN_KEYS.DOCUMENT]: "linkedDocuments",
  [ISSUE_COLUMN_KEYS.ATTACHMENTS]: "attachmentCount",
  [ISSUE_COLUMN_KEYS.COMMENTS]: "commentCount",
  [ISSUE_COLUMN_KEYS.LBS_LOCATION]: "locationId",
  [ISSUE_COLUMN_KEYS.ROOT_CAUSE]: "rootCauseId",
  [ISSUE_COLUMN_KEYS.ISSUE_TYPE_CATEGORY]: "issueTypeCategoryId",
  [ISSUE_COLUMN_KEYS.ISSUE_TYPE]: "issueTypeId",
  [ISSUE_COLUMN_KEYS.OPENED_AT]: "openedAt",
  [ISSUE_COLUMN_KEYS.CLOSED_AT]: "closedAt",
  [ISSUE_COLUMN_KEYS.UPDATED_AT]: "updatedAt",
  [ISSUE_COLUMN_KEYS.UPDATED_BY]: "updatedBy",
  [ISSUE_COLUMN_KEYS.DESCRIPTION]: "description",
  [ISSUE_COLUMN_KEYS.PLACEMENT]: "placement",
  [ISSUE_COLUMN_KEYS.IS_PUBLISHED]: "published",
  [ISSUE_COLUMN_KEYS.REFERENCES]: "references",
  [ISSUE_COLUMN_KEYS.DELETED_BY]: "deletedBy",
  [ISSUE_COLUMN_KEYS.DELETED_ON]: "deletedAt"
});
const ISSUE_COLUMN_SORT_ATTRS = exports.ISSUE_COLUMN_SORT_ATTRS = {
  [ISSUE_COLUMN_KEYS.STATUS]: _sdk.IssueSortingField.Status,
  [ISSUE_COLUMN_KEYS.ID]: _sdk.IssueSortingField.DisplayId,
  [ISSUE_COLUMN_KEYS.TITLE]: _sdk.IssueSortingField.Title,
  [ISSUE_COLUMN_KEYS.LOCATION_DETAILS]: _sdk.IssueSortingField.LocationDetails,
  [ISSUE_COLUMN_KEYS.CREATED_AT]: _sdk.IssueSortingField.CreatedAt,
  [ISSUE_COLUMN_KEYS.DUE_DATE]: _sdk.IssueSortingField.DueDate,
  [ISSUE_COLUMN_KEYS.START_DATE]: _sdk.IssueSortingField.StartDate,
  [ISSUE_COLUMN_KEYS.ROOT_CAUSE]: _sdk.IssueSortingField.RootCause,
  [ISSUE_COLUMN_KEYS.OPENED_AT]: _sdk.IssueSortingField.OpenedAt,
  [ISSUE_COLUMN_KEYS.CLOSED_AT]: _sdk.IssueSortingField.ClosedAt,
  [ISSUE_COLUMN_KEYS.UPDATED_AT]: _sdk.IssueSortingField.UpdatedAt,
  [ISSUE_COLUMN_KEYS.DESCRIPTION]: _sdk.IssueSortingField.Description,
  [ISSUE_COLUMN_KEYS.DELETED_ON]: _sdk.IssueSortingField.DeletedOn,
  [ISSUE_COLUMN_KEYS.DELETED_BY]: _sdk.IssueSortingField.DeletedBy,
  [ISSUE_COLUMN_KEYS.ISSUE_TYPE]: _sdk.IssueSortingField.IssueType,
  [ISSUE_COLUMN_KEYS.ISSUE_TYPE_CATEGORY]: _sdk.IssueSortingField.IssueTypeCategory,
  [ISSUE_COLUMN_KEYS.IS_PUBLISHED]: _sdk.IssueSortingField.Published
};
const COLUMN_KEY_BY_DATA_KEY = exports.COLUMN_KEY_BY_DATA_KEY = (0, _invert.default)(ISSUE_COLUMN_DATA_KEYS);
const COLUMN_KEY_BY_SORT_ATTRS = exports.COLUMN_KEY_BY_SORT_ATTRS = {
  [_sdk.IssueSortingField.Status]: ISSUE_COLUMN_KEYS.STATUS,
  [_sdk.IssueSortingField.DisplayId]: ISSUE_COLUMN_KEYS.ID,
  [_sdk.IssueSortingField.Title]: ISSUE_COLUMN_KEYS.TITLE,
  [_sdk.IssueSortingField.LocationDetails]: ISSUE_COLUMN_KEYS.LOCATION_DETAILS,
  [_sdk.IssueSortingField.CreatedAt]: ISSUE_COLUMN_KEYS.CREATED_AT,
  [_sdk.IssueSortingField.DueDate]: ISSUE_COLUMN_KEYS.DUE_DATE,
  [_sdk.IssueSortingField.StartDate]: ISSUE_COLUMN_KEYS.START_DATE,
  [_sdk.IssueSortingField.RootCause]: ISSUE_COLUMN_KEYS.ROOT_CAUSE,
  [_sdk.IssueSortingField.OpenedAt]: ISSUE_COLUMN_KEYS.OPENED_AT,
  [_sdk.IssueSortingField.ClosedAt]: ISSUE_COLUMN_KEYS.CLOSED_AT,
  [_sdk.IssueSortingField.UpdatedAt]: ISSUE_COLUMN_KEYS.UPDATED_AT,
  [_sdk.IssueSortingField.Description]: ISSUE_COLUMN_KEYS.DESCRIPTION,
  [_sdk.IssueSortingField.DeletedOn]: ISSUE_COLUMN_KEYS.DELETED_ON,
  [_sdk.IssueSortingField.DeletedBy]: ISSUE_COLUMN_KEYS.DELETED_BY,
  [_sdk.IssueSortingField.IssueType]: ISSUE_COLUMN_KEYS.ISSUE_TYPE,
  [_sdk.IssueSortingField.IssueTypeCategory]: ISSUE_COLUMN_KEYS.ISSUE_TYPE_CATEGORY,
  [_sdk.IssueSortingField.Published]: ISSUE_COLUMN_KEYS.IS_PUBLISHED
};
//# sourceMappingURL=columnKeys.js.map